const EVER_ELIGIBLE_LABEL = 'Ever Eligible';
const EVER_INTERACTED_LABEL = 'Ever Interacted';
const EVER_ENGAGED_LABEL = 'Ever Engaged';

/** Sub-label under the Ever Eligible funnel bar. */
export const ENGAGEMENT_FUNNEL_ELIGIBLE_SUBCOPY = 'Full eligible population';

/**
 * Builds the Ever Engaged funnel bar sub-label.
 * @param conversionPercent - Engaged ÷ ever interacted, 0–100.
 * @returns Copy such as `52% of Ever Interacted chose to engage`.
 */
export const formatEngagementFunnelEngagedSubCopy = (
  conversionPercent: number,
): string => `${conversionPercent}% of Ever Interacted chose to engage`;

/**
 * Resolves conversion percent for the Ever Engaged funnel note.
 * @param engaged - Ever engaged count.
 * @param interacted - Ever interacted count.
 * @returns Rounded percent, or null when interacted is 0.
 */
export const engagementFunnelConversionPercent = (
  engaged: number,
  interacted: number,
): number | null => {
  if (interacted <= 0) {
    return null;
  }
  return Math.round((engaged / interacted) * 100);
};

/**
 * Resolves engagement-story funnel bar sub-copy from step labels and counts.
 * @param stepLabel - Funnel step title.
 * @param steps - All funnel steps (used for Ever Engaged conversion).
 * @returns Canonical sub-copy, or undefined when the step keeps existing snapshot copy.
 */
export const resolveEngagementFunnelStepSubCopy = (
  stepLabel: string,
  steps: Array<{ label: string; value: number }>,
): string | undefined => {
  if (stepLabel === EVER_ELIGIBLE_LABEL) {
    return ENGAGEMENT_FUNNEL_ELIGIBLE_SUBCOPY;
  }
  if (stepLabel === EVER_ENGAGED_LABEL) {
    const engaged =
      steps.find(step => step.label === EVER_ENGAGED_LABEL)?.value ?? 0;
    const interacted =
      steps.find(step => step.label === EVER_INTERACTED_LABEL)?.value ?? 0;
    const percent = engagementFunnelConversionPercent(engaged, interacted);
    if (percent === null) {
      return undefined;
    }
    return formatEngagementFunnelEngagedSubCopy(percent);
  }
  return undefined;
};
